<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">超时配置</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <el-button style="margin-bottom: 40px" size="mini" type="primary" @click="addOverTimeSet">新增超时条件</el-button>
            <el-button style="margin-bottom: 40px" size="mini" type="primary" @click="addNotOverTimeSet">新增非超时条件</el-button>
            <el-button style="margin-bottom: 40px" size="mini" type="primary" @click="addOverTimeRules">新增超时规则</el-button>
            <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
              <el-table-column prop="id" label="id" width="150" />
              <el-table-column prop="setting_type_text" label="配置类型" />
              <el-table-column prop="content" label="规则说明" />
              <el-table-column label="使用开关">
                <template slot-scope="scope">
                  <el-switch class="switchStyle" active-text="开" inactive-text="关" v-model="scope.row.use_status" :inactive-value="0" :active-value="1" @change="switchChange(scope.row)"></el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="created_at" label="创建时间" />
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

            <el-dialog title="删除" center width="40%" :visible.sync="deleteShow">
              <p style="text-align: center">确认删除吗？</p>
              <div slot="footer" class="dialog-footer">
                <el-button @click="delCancel">取 消</el-button>
                <el-button type="primary" @click="delSure">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 新增超时条件的弹框 -->
            <el-dialog :title="overTimeSetObj.dialogTitle + '超时条件'" width="40%" :visible.sync="addOverTimeSetShow" @close="newOverTimeSetCancel">
              <div class="newOverTimeSet">
                <el-form :model="overTimeSetObj" label-width="100px">
                  <el-form-item label="选择时间：">
                    <el-time-picker v-model="overTimeSetObj.startTime" placeholder="任意时间点" value-format="HH:mm:ss"> </el-time-picker>
                    ~
                    <el-time-picker v-model="overTimeSetObj.endTime" value-format="HH:mm:ss" placeholder="任意时间点"> </el-time-picker>
                  </el-form-item>
                </el-form>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="newOverTimeSetCancel">取 消</el-button>
                <el-button type="primary" @click="newOverTimeSetSure">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 新增非超时条件的弹框 -->
            <el-dialog :title="notOverTimeSetObj.dialogTitle + '非超时条件'" width="40%" :visible.sync="addNotOverTimeSetShow" @close="newNotOverTimeSetCancel">
              <div class="newOverTimeSet">
                <el-form :model="notOverTimeSetObj" label-width="100px">
                  <el-form-item label="接待客服：">
                    <el-select v-model="notOverTimeSetObj.serviceInfo" placeholder="请选择">
                      <el-option v-for="item in serviceList" :key="item.id" :label="item.name" :value="item.name"> </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="选择时间：">
                    <el-date-picker style="margin-right: 5px" v-model="notOverTimeSetObj.chooseTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
                    <el-time-picker v-model="notOverTimeSetObj.startTime" placeholder="任意时间点" value-format="HH:mm:ss"> </el-time-picker>
                    ~
                    <el-time-picker v-model="notOverTimeSetObj.endTime" value-format="HH:mm:ss" placeholder="任意时间点"> </el-time-picker>
                  </el-form-item>
                </el-form>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="newNotOverTimeSetCancel">取 消</el-button>
                <el-button type="primary" @click="newNotOverTimeSetSure">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 新增超时规则 -->
            <el-dialog :title="OverTimeSetRulesObj.dialogTitle + '超时规则'" width="40%" :visible.sync="addOverTimeSetRulesShow" @close="newOverTimeSetRulesCancel">
              <div class="newOverTimeSet">
                <el-form :model="OverTimeSetRulesObj" label-width="120px">
                  <el-form-item label="时间（s）：">
                    <el-input placeholder="请输入" v-model="OverTimeSetRulesObj.time"></el-input>
                  </el-form-item>
                  <el-form-item label="会话数量范围：">
                    <el-input placeholder="最小值" v-model="OverTimeSetRulesObj.minChat"></el-input>
                    ~
                    <el-input placeholder="最大值" v-model="OverTimeSetRulesObj.maxChat"></el-input>
                  </el-form-item>
                  <el-form-item label="超时时间（s）：">
                    <el-input placeholder="请输入" v-model="OverTimeSetRulesObj.timeoutSeconds"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="newOverTimeSetRulesCancel">取 消</el-button>
                <el-button type="primary" @click="newOverTimeSetRulesSure">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOverTimeSetList, addOverTimeSetRules, getOverTimeSetRulesById, editOverTimeSetRules, changeOverTimeSetRulesSwitch, deleteOverTimeSetRulesById
} from '@/api/vipQualityTest.js';
import {
  getVipListApi
} from '@/api/testAnalysis.js';
import Dialog from '../../common/Dialog';
import Pagination from '@/components/pagination/index';
export default {
  components: {
    Dialog,
    Pagination
  },
  data() {
    return {
      listQuery: {
        page: 1,
        limit: 10,
      },
      listLoading: false,
      tableData: [],
      total: 0,
      addOverTimeSetShow: false, // 新增超时条件的弹窗控制字段
      overTimeSetObj: {
        id: '', // 编辑时候用到的id值
        dialogTitle: '新增',
        startTime: '',
        endTime: '',
      },
      addNotOverTimeSetShow: false, // 新增非超时条件的弹窗控制字段
      notOverTimeSetObj: {
        id: '',
        dialogTitle: '新增',
        serviceInfo: '', // 接待客服
        chooseTime: '', // 选择时间
        startTime: '',
        endTime: '',
      },
      serviceList: [], // 接待客服列表
      addOverTimeSetRulesShow: false, // 新增非超时条件的弹窗控制字段
      OverTimeSetRulesObj: {
        id: '',
        dialogTitle: '新增',
        time: '', // 
        minChat: '', // 
        maxChat: '',
        timeoutSeconds: '',
      },
      deleteShow: false,
      deleteId: 0,
    };
  },
  created() {
    this.getList(this.listQuery);
    this.getServiceList()
  },
  methods: {
    // 获取列表数据
    async getList(query) {
      this.listLoading = true;
      const { data } = await getOverTimeSetList(query);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.tableData = data.data.data;
      this.total = data.data.total;
      this.listLoading = false;
    },
    // 获取接待客服列表数据
    async getServiceList() {
      const { data } = await getVipListApi()
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.serviceList = data.data
      // console.log(data)
    },
    // 删除
    async del(row) {
      this.deleteShow = true;
      this.deleteId = row.id;
    },
    // 取消删除
    delCancel() {
      this.deleteId = 0;
      this.deleteShow = false;
    },
    // 删除确定
    async delSure() {
      const { data } = await deleteOverTimeSetRulesById(this.deleteId);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('删除成功');
      this.delCancel();
      this.getList(this.listQuery);
    },
    // 新增超时条件设置
    addOverTimeSet() {
      this.overTimeSetObj.dialogTitle = '新增'
      this.addOverTimeSetShow = true
    },
    newOverTimeSetCancel() {
      this.addOverTimeSetShow = false
      this.overTimeSetObj.startTime = ''
      this.overTimeSetObj.endTime = ''
    },
    async newOverTimeSetSure() {
      const addData = {
        setting_type: 1,
        begin_time: this.overTimeSetObj.startTime,
        end_time: this.overTimeSetObj.endTime
      }
      const { data } = this.overTimeSetObj.dialogTitle === '新增' ? await addOverTimeSetRules(addData) : await editOverTimeSetRules({ ...addData, id: this.overTimeSetObj.id })
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      // console.log(data)
      this.$message.success('操作成功');
      this.newOverTimeSetCancel();
      this.getList(this.listQuery);
    },
    // 新增非超时条件
    addNotOverTimeSet() {
      this.addNotOverTimeSetShow = true
      this.notOverTimeSetObj.dialogTitle = '新增'
    },
    newNotOverTimeSetCancel() {
      this.addNotOverTimeSetShow = false
      for (let prop in this.notOverTimeSetObj) {
        // console.log(prop)
        this.notOverTimeSetObj[prop] = ''
      }
    },
    async newNotOverTimeSetSure() {
      const addData = {
        setting_type: 2,
        admin_name: this.notOverTimeSetObj.serviceInfo,
        date: this.notOverTimeSetObj.chooseTime,
        begin_time: this.notOverTimeSetObj.startTime,
        end_time: this.notOverTimeSetObj.endTime
      }
      const { data } = this.notOverTimeSetObj.dialogTitle === '新增' ? await addOverTimeSetRules(addData) : await editOverTimeSetRules({ ...addData, id: this.notOverTimeSetObj.id })
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      // console.log(data)
      this.$message.success('操作成功');
      this.newNotOverTimeSetCancel();
      this.getList(this.listQuery);
    },
    // 新增超时规则
    addOverTimeRules() {
      this.addOverTimeSetRulesShow = true
      this.OverTimeSetRulesObj.dialogTitle = '新增'
    },
    newOverTimeSetRulesCancel() {
      this.addOverTimeSetRulesShow = false
      for (let prop in this.OverTimeSetRulesObj) {
        // console.log(prop)
        this.OverTimeSetRulesObj[prop] = ''
      }
    },
    async newOverTimeSetRulesSure() {
      const addData = {
        setting_type: 3,
        calc_seconds: this.OverTimeSetRulesObj.time,
        min_chat: this.OverTimeSetRulesObj.minChat,
        max_chat: this.OverTimeSetRulesObj.maxChat,
        timeout_seconds: this.OverTimeSetRulesObj.timeoutSeconds
      }
      const { data } = this.OverTimeSetRulesObj.dialogTitle === '新增' ? await addOverTimeSetRules(addData) : await editOverTimeSetRules({ ...addData, id: this.OverTimeSetRulesObj.id })
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      // console.log(data)
      this.$message.success('操作成功');
      this.newOverTimeSetRulesCancel();
      this.getList(this.listQuery);
    },
    // 编辑列表相关条件规则
    edit(row) {
      console.log(row);
      if (row.setting_type === 1) {
        this.overTimeSetObj.dialogTitle = '编辑'
        this.addOverTimeSetShow = true
      } else if (row.setting_type === 2) {
        this.notOverTimeSetObj.dialogTitle = '编辑'
        this.addNotOverTimeSetShow = true
      } else if (row.setting_type === 3) {
        this.OverTimeSetRulesObj.dialogTitle = '编辑'
        this.addOverTimeSetRulesShow = true
      }
      this.getOverTimeInfoById(row)
    },
    // 根据id获取超时时间相关规则信息
    async getOverTimeInfoById(row) {
      const { data } = await getOverTimeSetRulesById(row)
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      // console.log(data)
      if (data.data.setting_type === 1) {
        this.overTimeSetObj.id = data.data.id
        this.overTimeSetObj.startTime = data.data.begin_time
        this.overTimeSetObj.endTime = data.data.end_time
      } else if (data.data.setting_type === 2) {
        this.notOverTimeSetObj.id = data.data.id
        this.notOverTimeSetObj.startTime = data.data.begin_time
        this.notOverTimeSetObj.endTime = data.data.end_time
        this.notOverTimeSetObj.serviceInfo = data.data.admin_name
        this.notOverTimeSetObj.chooseTime = data.data.date
      } else if (data.data.setting_type === 3) {
        this.OverTimeSetRulesObj.id = data.data.id
        this.OverTimeSetRulesObj.time = data.data.calc_seconds
        this.OverTimeSetRulesObj.minChat = data.data.min_chat
        this.OverTimeSetRulesObj.maxChat = data.data.max_chat
        this.OverTimeSetRulesObj.timeoutSeconds = data.data.timeout_seconds
      }
    },
    // 切换超时时间设置的 switch 开关
    async switchChange(row) {
      // console.log(row)
      const { data } = await changeOverTimeSetRulesSwitch(row)
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.getList(this.listQuery);
    }
  },
};
</script>

<style lang="scss" scoped>
.el-date-editor {
  width: 150px;
}
.el-input {
  width: 150px;
}
.newOverTimeSet {
  display: flex;
  justify-content: center;
}
</style>
<style lang="scss">
.switchStyle .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}
.switchStyle .el-switch__label--left {
  z-index: 9;
  left: 6px;
}
.switchStyle .el-switch__label--right {
  z-index: 9;
  left: -14px;
}
.switchStyle .el-switch__label.is-active {
  display: block;
}
.switchStyle.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 50px !important;
}
</style>